<template>
  <div>
    <v-container fluid>
      <h1>Twitter Integration</h1>
      <div class="card-curvey" v-for="app in apps">
        <v-layout class="align-center">
          <v-flex xs8>
            <h2>{{ app.screen_name }}</h2>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  v-on="on"
                  dark
                  small
                  color="error"
                  @click="deleteAccount(app)"
                >
                  <v-icon dark>delete_outline</v-icon>
                </v-btn>
              </template>
              <span>unsubscribe</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </div>

      <div class="card-curvey">
        <v-text-field
          v-model="preConnectData.username"
          placeholder="Screen name"
          outline
        />
        <v-btn
          @click="connectTwitter"
          :loading="btnLoader"
          class="mt-2"
          color="primary"
        >
          <v-icon>mdi-twitter</v-icon>
          Connect Twitter
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import env from "../../../../utils/env";
export default {
  name: "twitter",
  data() {
    return {
      apps: [],
      btnLoader: false,
      preConnectData: {
        username: "",
        dashboard_redirection_url: "",
      },
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const accountId = urlParams.get("account_id");
    const userName = urlParams.get("username");
    const remove = urlParams.get("removed");
    const error = urlParams.get("error");

    if (accountId) {
      this.mapApp(userName, accountId);
    } else if (remove) {
      this.removeApp(userName);
    } else {
      this.getApps();
    }

    if (error && error !== "null") {
      this.$store.dispatch("setSnackbar", {
        text: error,
        color: "error",
        status: true,
      });
    }
  },
  methods: {
    connectTwitter() {
      this.btnLoader = true;
      this.preConnectData.dashboard_redirection_url =
        window.location.href.split("?")[0];
      this.$http_twitter
        .post("accounts", this.preConnectData)
        .then((res) => {
          setTimeout(() => {
            window.location.href = `${env.TWITTER_SUBSCRIPTION_URL}/subscriptions/add?redirection_url=${this.windowLocation}`;
          }, 5000);
        })
        .catch((err) => {
          this.btnLoader = false;
        });
    },
    deleteAccount(app) {
      this.$store.dispatch("setLoader", true);
      this.preConnectData.dashboard_redirection_url =
        window.location.href.split("?")[0];
      this.preConnectData.username = app.screen_name;
      this.$http_twitter
        .post("accounts", this.preConnectData)
        .then((res) => {
          setTimeout(() => {
            window.location.href = `${this.subscriptionUrl}/subscriptions/remove?redirection_url=${this.windowLocation}`;
            this.$store.dispatch("setLoader", false);
          }, 5000);
        })
        .catch((err) => {
          this.$store.dispatch("setLoader", false);
        });
    },
    getApps() {
      this.$store.dispatch("setLoader", true);
      this.$http_session_manager
        .get(`bots/${this.$store.state.bot.botId}/apps?channel=twitter`)
        .then((res) => {
          this.$store.dispatch("setLoader", false);
          this.apps = res.data.data;
        })
        .catch((err) => {
          this.$store.dispatch("setLoader", false);
        });
    },
    addApp(userName) {
      this.$http_session_manager
        .put(`bots/${this.$store.state.bot.botId}/apps/twitter`, {
          screen_name: userName,
        })
        .then((res) => {
          this.getApps();
        })
        .catch((err) => {
          this.$store.dispatch("setLoader", false);
        });
    },
    mapApp(userName, accountId) {
      this.$store.dispatch("setLoader", true);
      this.$http_twitter
        .patch(`accounts/${accountId}/bot`, {
          webhook_url: `${env.TWITTER_WEBHOOK_URL}${userName}/messages`,
          environment: env.TWITTER_ENV,
        })
        .then((res) => {
          this.addApp(userName);
        })
        .catch((err) => {
          this.$store.dispatch("setLoader", false);
        });
    },
    removeApp(userName) {
      this.$store.dispatch("setLoader", true);
      this.$http_session_manager
        .delete(
          `/bots/${this.$store.state.bot.botId}/apps/${userName}?provider=twitter`
        )
        .then((res) => {
          this.$store.dispatch("setLoader", false);
          this.getApps();
        })
        .catch((err) => {});
    },
  },
  computed: {
    windowLocation() {
      return window.location.href;
    },
    subscriptionUrl() {
      return env.TWITTER_SUBSCRIPTION_URL;
    },
  },
};
</script>

<style scoped></style>
